import { render, staticRenderFns } from "./PVIReportHistory.vue?vue&type=template&id=5bc619db&"
import script from "./PVIReportHistory.vue?vue&type=script&lang=js&"
export * from "./PVIReportHistory.vue?vue&type=script&lang=js&"
import style0 from "./PVIReportHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/PVIReportHistory.vue
// module id = null
// module chunks = 